import { render, staticRenderFns } from "./PagosBolivianos.vue?vue&type=template&id=3777eed8"
import script from "./PagosBolivianos.vue?vue&type=script&lang=js"
export * from "./PagosBolivianos.vue?vue&type=script&lang=js"
import style0 from "./PagosBolivianos.vue?vue&type=style&index=0&id=3777eed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports